import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Section from './section';
import DecisionCardLite from '../decision-card-lite';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';
import {stackDecisionFields, stackFields} from '../../../../data/shared/fragments';
import {withMutation} from '../../../../shared/enhancers/graphql-enhancer';
import {trackViews} from '../../../../data/shared/mutations.js';
import {callTrackViews} from '../../../../../app/shared/utils/trackViews.js';

export const query = gql`
  query companyDecisions($id: ID!, $orgId: ID, $first: Int, $after: String) {
    company(id: $id) {
      id
      stackDecisions(orgId: $orgId, first: $first, after: $after) {
        count
        edges {
          node {
            answers(first: 2) {
              count
              pageInfo {
                hasNextPage
                endCursor
              }
              edges {
                node {
                  ...stackDecisionFields
                }
              }
            }
            id
            htmlContent
            private
            topics {
              name
            }
            upvotesCount
            user {
              id
              username
              imageUrl
              displayName
              title
              companyName
            }
            viewCount
            stack {
              ...stackFields
            }
            services {
              id
              name
              imageUrl
            }
            ...stackDecisionFields
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${stackFields}
  ${stackDecisionFields}
`;

const Decisions = ({companyId, trackViews, currentOrg, count}) => {
  const isMobile = useContext(MobileContext);
  return (
    <Section
      title="Decisions"
      count={count}
      query={query}
      dataKey="stackDecisions"
      variables={{id: companyId, orgId: currentOrg && currentOrg.id}}
      gridCols={isMobile ? 1 : 2}
    >
      {({edges}) => {
        return edges.length > 0 ? (
          <DecisionComponent edges={edges} trackViews={trackViews} />
        ) : (
          'No Decisions Found!'
        );
      }}
    </Section>
  );
};

const DecisionComponent = ({edges, trackViews}) => {
  const [tracked, setTracked] = useState(0);

  useEffect(() => {
    const decisionIds = edges.slice(tracked).map(dec => dec.node.id);
    setTracked(edges.length);
    callTrackViews({
      trackViews,
      decisionIds,
      clientContext: `DecisionComponent-${window.location.pathname}`
    });
  }, [edges]);

  return edges.map(e => <DecisionCardLite key={e.node.id} decision={e.node} />);
};

Decisions.propTypes = {
  companyId: PropTypes.any.isRequired,
  trackViews: PropTypes.func,
  currentOrg: PropTypes.object,
  count: PropTypes.number.isRequired
};

export default withMutation(trackViews, mutate => ({
  trackViews: (decisionIds, clientContext) => mutate({variables: {decisionIds, clientContext}})
}))(Decisions);
